import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=3aabe0b4&"
import script from "./Attributes.vue?vue&type=script&lang=js&"
export * from "./Attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aabe0b4')) {
      api.createRecord('3aabe0b4', component.options)
    } else {
      api.reload('3aabe0b4', component.options)
    }
    module.hot.accept("./Attributes.vue?vue&type=template&id=3aabe0b4&", function () {
      api.rerender('3aabe0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/KeyPlan/Summaries/Attributes.vue"
export default component.exports